import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { DatePicker, Row, Col, Form, AutoComplete, Input, Radio } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import useDispatchHttp from '../../../hooks/dispatchHttpHandler'
import { fetchAllUsers, selectAllUsersForSelect } from '../../../state/modules/users'
import { DATE_FORMAT } from '../../../constants'
import { useUser } from '../../../providers/UserProvider'
import useDebounce from '../../../hooks/useDebounce'

const defaultActorOptions = [
  {
    label: 'All',
    value: 'all',
  },
]

const ActivityLogFiltersCases = ({ updateSearchParam, searchParams }) => {
  const dispatchHttp = useDispatchHttp()
  const [actorOptions, setActorOptions] = useState([...defaultActorOptions])
  const [actorDisplayValue, setActorDisplayValue] = useState('')
  const { id, firstname, lastname } = useSelector(state => state.auth)
  const users = useSelector(selectAllUsersForSelect)
  const { isUserActionAllowed } = useUser()
  const [form] = Form.useForm()

  useEffect(() => {
    let opts
    if (isUserActionAllowed('view_user')) {
      opts = [...defaultActorOptions, ...users]
    } else {
      opts = [{ value: id, label: `${firstname} ${lastname}` }]
    }
    setActorOptions(opts)
    const currentValue = searchParams.user_id || searchParams.edited
    const matchedOption =
      currentValue !== 'all' ? opts.find(o => o.value === currentValue) : null
    setActorDisplayValue(matchedOption?.label || '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users])

  useEffect(() => {
    if (isUserActionAllowed('view_user')) {
      dispatchHttp(fetchAllUsers({ skipPagination: true }))
    }
  }, [dispatchHttp, isUserActionAllowed])

  const handleSelect = value => {
    let param
    const isDefaultActorOption = defaultActorOptions.filter(
      variant => value === variant.value
    ).length

    if (isDefaultActorOption) {
      param = { edited: value }
    } else {
      param = { user_id: value }
    }

    updateSearchParam(param)
  }

  const handleFilterByDate = (dates, datesString) => {
    const date_range = datesString.filter(date => !!date).toString()

    updateSearchParam({ date_range })
  }

  const filteredActorOptions = actorDisplayValue
    ? actorOptions.filter(o =>
        o.label.toLowerCase().includes(actorDisplayValue.toLowerCase())
      )
    : actorOptions

  const handleActorSelect = (value, option) => {
    handleSelect(value)
    setActorDisplayValue(value === 'all' ? '' : option.label)
  }

  const handleActorInputChange = text => {
    setActorDisplayValue(text)
  }

  const handleChangeSearch = useDebounce(e => {
    const { value } = e.target
    updateSearchParam({ search: value.trim() })
  }, 500)

  const handleSort = ({ target: { value, name } }) => {
    const sort = { [name]: value }

    updateSearchParam(sort)
  }

  return (
    <Row className="activity-log-filter-form" justify="end" align="bottom">
      <Col>
        <Form form={form} layout="inline" className="sort-form" component="div">
          <Row gutter={[20, 20]}>
            <Col>
              <Input
                onChange={handleChangeSearch}
                type="text"
                className="search-input"
                placeholder="CMS Case ID"
                style={{ width: 200 }}
              />
            </Col>
            <Col>
              <DatePicker.RangePicker
                format={DATE_FORMAT.year_month_day}
                onChange={handleFilterByDate}
              />
            </Col>
            <Col>
              <Form.Item label="Actor" className="sort-form__select-field">
                <AutoComplete
                  size="middle"
                  className="sort-form__select"
                  value={actorDisplayValue}
                  options={filteredActorOptions}
                  onSelect={handleActorSelect}
                  onChange={handleActorInputChange}
                  notFoundContent="No results found"
                >
                  <Input placeholder="Search..." suffix={<SearchOutlined />} />
                </AutoComplete>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item wrapperCol={{ offset: 2, span: 24 }}>
                <Radio.Group
                  defaultValue="-created_at"
                  name="ordering"
                  onChange={handleSort}
                  value={searchParams.ordering}
                >
                  <Radio.Button value="-created_at">New First</Radio.Button>
                  <Radio.Button value="created_at">Old First</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  )
}

export default ActivityLogFiltersCases
